import {Component, OnInit} from '@angular/core';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ConfiguratorI18nCacheService, SelectItem} from '@tj/tj-dmp-lib-api';
import {TranslateService} from '@ngx-translate/core';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {ValidatorEditorService} from "../validator-editor.service";

@Component({
    selector: 'dmp-city-editor',
    templateUrl: './city-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class CityEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected translate: TranslateService,
                protected cacheI18n: ConfiguratorI18nCacheService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return (value as SelectItem).key;
    }

    ngOnInit(): void {
        this.init();
        this.originalValue = this.value;
        this.cacheI18n.searchUsingGET('CITY', true).subscribe(res => {
            this.items = res.filter(i => i.value && i.value.length>0).map(i => ({label: i.value, key: i.key} as SelectItem));
            if (this.value && this.value !== 'null') {
                const currentValue = this.items.find(i => i.key === this.value);
                if (currentValue) {
                    this.formGroup.get('value').setValue(currentValue);
                } else {
                    this.dataNotFound.next(this.field);
                }
            }
        });
    }
}
